module.exports = __webpack_public_path__ + "static/media/13-2.826135a1.mp3";